var SuppressionQueryKeys={statuses:['suppressions','statuses']};export{SuppressionQueryKeys};